import React, { Component } from 'react';
import { connect } from 'react-redux';
import {Link} from "react-router-dom"
import { Row , Col, Icon, Progress, Spin} from 'antd';
import classnames from "classnames"
import { getCourse, getSections } from '../../../../core/actions/courseGet';
import { videoCompleted } from '../../../../core/actions/playlist';
import {bindActionCreators} from "redux"
import { postLastView } from '../../../../core/actions/coursePost';
import { getLastView } from '../../../../core/actions/courseGet';
class Videoplaylist extends Component {
  constructor(props) {
    super(props);

    this.state = {
      sections: [],
      lectures:[],
      percentage:0,
      activeLecture:{}
    };
  }
  componentWillReceiveProps(nextProps) {
    if(nextProps.auth.isEmpty) this.props.history.push(`/courses/${nextProps.course.slug}`)
    const { course, sections,lastViewCourse, auth } = nextProps;
    var lectures =[]
    var percentage=0; var completed = 0;
    // if (course) this.setState({ course });
    if (sections.length > 0 && course) {
    sections.sort((a,b)=>a.position>b.position?1:-1)
    sections.map((sect)=>{
    sect.lectures.sort((a,b)=>a.position>b.position?1:-1)
    lectures = lectures.concat(sect.lectures)
    sect.lectures.map((lect,key)=>{
          if(lect.completed) completed+=1
    })
    
  })
  percentage = (completed * 100)/lectures.length
  this.setState({ sections, lectures , percentage:Math.floor(percentage),course,
    activeLecture:nextProps.activeLecture.video?nextProps.activeLecture:sections[0].lectures[0]})
    }
    if(lastViewCourse.id === this.props.course.id){
      sections.map((sect)=>{
        sect.lectures.map((lect)=>{
          if(lastViewCourse.lastLectId === lect.id){
              this.setState({activeLecture:lect},()=>{
                var video = document.getElementById('vid');
                video.currentTime = lastViewCourse.currentTime
              })

            }
        })
      })
      // this.setState({activeLecture})
    }
    // if (!auth.uid) this.context.router.push('/');
  }
  
  componentWillMount() {
    window.scrollTo({ top: 0 });
    var profileUid = localStorage.getItem("uid")
    const { slug } = this.props.match.params;
    this.props.getCourse(slug);
    this.props.getSections(slug);
    if(profileUid){
      this.props.getLastView(profileUid)
    }
  }

  componentWillUnmount(){
    var video = document.getElementById('vid');
    this.props.postLastView({
      courseId: this.state.course.id,
      lectureId: this.state.activeLecture.id,
      currentTime:video.currentTime,
      userId: this.props.profile.uid
    })
  }
  select=(activeLect)=>{
    var {sections,activeLecture,lectures} = this.state
    var percentage; var completed = 0;
    sections.map((sect)=>{
      sect.lectures.map((lect)=>{
          if(lect.id === activeLecture.id)lect.completed= true
          if(lect.completed) completed+=1
      })
    })
    percentage = (completed * 100)/lectures.length

    this.setState({activeLecture:activeLect,percentage:Math.floor(percentage)})
    this.completed()
  }
  checkIconStatus = (lecture)=>{
    if(this.state.activeLecture.video===lecture.video)
    return <i className="anticon"><svg width="1em" height="1em" fill="currentColor" aria-hidden="true" focusable="false" className="" viewBox="0 0 1024 1024"><path d="M16 512c0 273.932 222.066 496 496 496s496-222.068 496-496S785.932 16 512 16 16 238.066 16 512z m496 368V144c203.41 0 368 164.622 368 368 0 203.41-164.622 368-368 368z"></path></svg></i>
    else if(lecture.completed)
    return <Icon type="check-circle" theme="filled" />
    else return <Icon type="play-circle" />
  }
  previousLecture =(e)=>{
    e.preventDefault()
    var {lectures,activeLecture} = this.state
    var index = lectures.findIndex((lect)=>activeLecture.id === lect.id)
    if(index){
      this.setState({activeLecture:lectures[index-1]})
    }
  }
  nextLecture =(e)=>{
    e.preventDefault()
    var {lectures,sections,activeLecture} = this.state
    var index = lectures.findIndex((lect)=>activeLecture.id === lect.id)
    var percentage; var completed = 0;
    sections.map((sect,key)=>{
      sect.lectures.map((lect,key)=>{
          if(lect.id === activeLecture.id)lect.completed= true;
          if(lect.completed) completed+=1
      })
    })
    percentage = (completed * 100)/lectures.length
    if(index !== (lectures.length -1)){
      this.setState({activeLecture:lectures[index+1],percentage:Math.floor(percentage),sections})
    }else this.setState({percentage:Math.floor(percentage)})
    this.completed()
  }

  completed = () =>{
    var {sections,activeLecture} = this.state
    var courseId= this.props.course.id;
    var sectionId,lectureId;
    var userId = this.props.auth.uid
    sections.map((sect,key)=>{
      sect.lectures.map((lect,key)=>{
          if(lect.id === activeLecture.id) {
            sectionId= sect.id;
            lectureId = lect.id;
          }
      })
    })
    var data ={courseId,sectionId,lectureId,userId}
    this.props.videoCompleted(data)
  }
 

  render() {
    var { course, sections,activeLecture, percentage, toggleAction } = this.state;
    const loading = !sections.length > 0;
    return( <div id="playlistcontent">
        
        {course && sections.length > 0 ?
          <section >
            <Row className="x-playlist-box" type="flex">
              <Col className="xleft-grid"  xs={24}  sm={24} md={6} lg={6}>
                <div className="xheader">
                <div>
                <Icon type="left-circle" className="xcursor" onClick={()=>this.props.history.goBack()} theme="filled" />
                </div>
                <div style={{textAlign:"right"}}>
                <Icon className="xcursor" onClick={()=>this.props.history.push("/settings")} type="setting" theme="filled" />
                </div>
                </div>
                  <div className="xcontent">
                  <div className="xprogress-box">
                  <div className="xprogress">
                  <Progress  percent={percentage} status="active" showInfo={false}/>
                  <b className="open-sans2"> {percentage} % </b> <span>complete</span>
                  
                  </div>
                  </div>
                  
                    {sections && sections.map((section,key) => (
                          <div className="xsection" key={key}>
                            <div className={classnames("xcat")}>
                              {section.title}
                            </div>
                            {section.lectures.map((lecture, lecIndex) => (
                               <div>
                                 <div onClick={()=>this.select(lecture)} className={classnames("xitem",lecture.id === activeLecture.id?"active":null,lecture.completed?"completed":null)} key={lecIndex}>
                                  <div className="xicon">
                                    {this.checkIconStatus(lecture)}
                                  </div>
                                  <div className="xtitle">
                                  <Icon type="youtube" theme="filled"  style={{marginRight:"5px"}}/> {lecture.title}
                                  </div>
                                </div>
                                {lecture.files&&lecture.files.map((file,i)=>(
                                  <div onClick={()=>window.open(file.url,"__blank")} className={classnames("xitem")} key={i}>
                                  <div className="xicon">
                                    {/* {this.checkIconStatus(lecture)} */}
                                  </div>
                                  <div className="xtitle">
                                  <Icon type="file"  style={{marginRight:"5px"}}/> {file.name}
                                  </div>
                                  </div>
                                  ))}
                                </div>
                            ))}
                          </div>
                        ))}
                </div>
                
              </Col>
              <Col className="xright-grid"  xs={24}  sm={24} md={18} lg={18}>
                <Row type="flex" align="middle" className="xheader">
                  <Col className="left-xheader xcursor" xs={12}  onClick={this.previousLecture} sm={12} md={12} lg={12}>
                    <div  >
                     <Icon type="arrow-left" /> Previous Lecture
                    </div>
                  </Col>
                  <Col  className="right-xheader xcursor" onClick={this.nextLecture} xs={12}  sm={12} md={12} lg={12}>
                    <div >
                    Next Lecture <Icon type="arrow-right" /> 
                    </div>
                  </Col>
                </Row>
                <div className="xvideo-content">
                  <div className="xtitle">
                  <Icon type="youtube" theme="filled"  style={{marginRight:"5px"}}/> {activeLecture.title}
                  </div>
                  <div className="xvideo-container">
                  <center>
                    <video id="vid" key={activeLecture.video} className="x-player"   controls>
                      <source src={activeLecture.video} />
                      Your browser does not support the video tag.
                      <Icon type="caret-left" />
                    </video>
                    </center>
                  </div>
                </div>
              </Col>
            </Row>
          </section>
              :
              <div className="x-loader"> 
      <Icon type="loading" style={{ fontSize: 60 }} spin />
      </div>}
      </div>)
  }
}

const mapStateToProps = state => ({
  auth: state.firebase.auth,
  profile: state.firebase.profile,
  course: state.getCourses.course,
  lastViewCourse: state.getCourses.lastViewCourse,
  sections: state.getCourses.sections,
  activeLecture: state.playlistReducer.activeLecture
});
const mapDispatchToProps = (dispatch)=>bindActionCreators({
    getSections,
    getCourse,
    getCourse,
    postLastView,
    getLastView,
    videoCompleted
},dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Videoplaylist);
